import { Injectable } from '@angular/core';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SectionChartContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getGraficos(id: string): Observable<any> {
    return this.getGraficosContents(id).pipe(
      map(res =>
        this.buildReponseChartsObject(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryGraficosContents[0].data;
  }

  private getGraficosContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryGraficosContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            tipo {
              iv
            }
            eixo {
              iv {
                valor
                rotulo
                cor
              }
            }
            categoria {
              iv
            }
            descricao {
              iv
            }
            rodape {
              iv
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildReponseChartsObject(response: any) {
    const chart = {
      barChartLabels: [],
      barChartType: response.tipo.iv === 'Vertical' ? 'bar' : 'horizontalBar',
      barChartColors: [],
      barChartLegend: false,
      barChartPlugins: [pluginDataLabels],
      barChartData: [],
      barChartOptions: {
        responsive: true,
        tooltips: { enabled: false },
        legend: { display: false },
        scales: {
          xAxes: [
            {
              display: response.tipo.iv === 'Vertical',
              gridLines: { display: true }
            }
          ],
          yAxes: [
            {
              display: response.tipo.iv !== 'Vertical',
              gridLines: { display: true }
            }
          ]
        },
        layout: {
          padding: {
            left: 0,
            right: 30,
            top: 20,
            bottom: 0
          }
        },
        plugins: { datalabels: { anchor: 'end', align: 'end' } }
      }
    };

    if (response.eixo) {
      const barChartColors = { backgroundColor: [] };
      const barChartData = {
        maxBarThickness: 40,
        data: []
      };
      response.eixo.iv.forEach(eixo => {
        barChartColors.backgroundColor.push(eixo.cor);
        barChartData.data.push(eixo.valor);
        chart.barChartLabels.push([eixo.rotulo]);
      });

      chart.barChartColors.push(barChartColors);
      chart.barChartData.push(barChartData);
    }

    return {
      title: response.titulo ? response.titulo.iv : '',
      subtitle: response.subtitulo ? response.subtitulo.iv : '',
      description: response.descricao ? response.descricao.iv : '',
      footer: response.rodape ? response.rodape.iv : '',
      chart
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
